export default __webpack_public_path__ + "static/7-e93f14557cb6c3d50c4248b53dc50619.jpg";